import React, { useState, useEffect } from 'react';
import { api } from '../../../common/app';
import { Toast, Button } from 'antd-mobile';
import Layout from '../component/layout'
import { useHistory } from 'react-router-dom'
import Card from '../component/card';
import { useUserStatus } from '../../../common/hooks/user-status';
import moment from 'moment'

export default (props: any) => {
  const { id } = props.match.params;
  const history = useHistory();
  // 是否显示酒店数据
  const [showHotel, setShowHotel] = useState(true);
  // 酒店数据
  const [data, setData] = useState({} as any);
  const { userstatus } = useUserStatus(id);
  const [loading, setLoading] = useState(true);

  // 请求数据
  useEffect(() => {
    (api as any).myPlain({ meetid: id })
      .then((result: any) => {
        if (result.code === 200) {
          setData(result.result);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      })
      .catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      });
  }, []);

  // 都没有不显示
  useEffect(() => {
    if (data.send_data && data.join_data && data.send_data.is_need === false && data.join_data.is_need === false) {
      setShowHotel(false);
    }
  }, [data]);

  // 跳转到修改
  const onEdit = (item: any) => {
    history.push(`/mine/plain/${id}/${item.id}`);
  }

  const onAdd = () => {
    history.push(`/mine/plain/${id}`);
  }


  const renderCard = (cardData: any, canedit: boolean) => {
    return (
        <Card
            edit={canedit && "修改"}
            type={cardData?.type === 1 ? "train" : "plane"}
            title={`${cardData.give_type === 1 ? '接' : '送'}${cardData?.type === 1 ? "站点：" : "机点："}${
                cardData?.give_plain_location
            }`}
            status={`${cardData?.type === 1 ? "车次号：" : "航班号："}${
                cardData?.give_plain_times
            }`}
            time={``}
            onClick={() => onEdit(cardData)}
        >
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span>接送日期：{cardData?.give_plain_time_str}</span>
                <span>
                    接送时间：{moment(cardData.give_plain_time * 1000).format("HH:mm")}
                </span>
                <span>备注信息：{cardData?.remark || '无'}</span>
            </div>
        </Card>
    );
  }

  return (
    <Layout
      loading={loading}
      meetid={id}
      status={userstatus.is_plain}
      type="plane"
      data={[data?.join_data || {}, data?.send_data || {}]}
      renderCard={renderCard}
      is_expire={data?.is_expire}
    />
  );
}